import Http from './http'

export default {
	index(filters){
    return Http.get(`/api_keys`, {params: {...filters}})
  },
  indexByModel({model, id}){
    return Http.get(`/${model}/${id}/api_keys`)
  },
  show(id){
    return Http.get(`/api_keys/${id}`)
  },
  create(new_api_key){
    return Http.post(`/api_keys`,{
      api_key:{ 
        ...new_api_key
      }
    });
  },
  update(up_api_key){
    return Http.put(`/api_keys/${up_api_key.id}`,{
      api_key:{ 
        ...up_api_key
      }
    });
  },
}